import React from 'react'
import ProductPageShell from './ProductPageShell'

export default function ProductLoadFailure({ message, onRetry, title = 'We couldn’t load these headphones' }: {
  message: string
  onRetry: () => void
  title?: string
}) {
  return <ProductPageShell
    navContent={<div className="standard_container flex !flex-row justify-between items-center">
      <span>Headphones unavailable</span>
      <button disabled className="rounded-md bg-grey px-4 py-2 opacity-50 cursor-not-allowed">Add to Basket</button>
    </div>}
    mainContent={<div data-prerender-error="product" data-nosnippet="" role="alert" className="w-full py-16 text-center">
      <h1 className="font-headline text-3xl mb-4">{title}</h1>
      <p className="mb-6">{message}</p>
      <button onClick={onRetry} className="rounded-md bg-orange text-white px-6 py-3">Try again</button>
    </div>}
  />
}
